import { render, staticRenderFns } from "./Marketplace.vue?vue&type=template&id=52773c9f&scoped=true"
import script from "./Marketplace.vue?vue&type=script&lang=js"
export * from "./Marketplace.vue?vue&type=script&lang=js"
import style1 from "./Marketplace.vue?vue&type=style&index=1&id=52773c9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52773c9f",
  null
  
)

export default component.exports